import { AxiosInstance, CancelTokenSource } from 'axios';
import { moneyInterface } from '@/compiler/types';
import baseAxios from '@/helpers/forms/axios';

export interface statisticResult {
    arrivingShipments: number[]
    arrivingItemsCount: number
    shippedShipmentsCount?: number
    workingShipmentsCount?: number
    receivedTodayShipments: number[]
    receivedTodayItemsCount: number
    lastSevenDaysReceivedItems: number[]
    lastSevenDaysShippedItems?: number[]
    totalItemsToday: number
    totalShipmentsToday: number
    unpaidChargesCount: number
    totalUnpaidCharges: moneyInterface
    openChargesCount: number
    totalOpenCharges: moneyInterface
    orderStats?: {
        totalPendingOrder: number
        totalShippedToday: number
        shippedLastSevenDays: number[]
        totalOrderShippedLastSevenDays: number
    }
    openShipmentsItemCount: number
    shippedShipmentsItemCount: number
    itemsInInventoryCount: number
    shippedAmazonShipmentsItemCount: number
    arrivedAmazonItemCount: number
    totalInStockQuantity: number
    totalAvailableQuantity: number
    totalUnavailableQuantity: number
    totalAllocatedQuantity: number
    totalInboundQuantity: number
    stockCachedAt: string
}

export default (axios: AxiosInstance = baseAxios): { fetchMerchantStatistics: (cancelTokenSource: CancelTokenSource) => Promise<statisticResult>; fetchServiceProviderStatistics: (cancelTokenSource: CancelTokenSource) => Promise<statisticResult>; checkOauthSession: () => Promise<string | null>; } => ({
    fetchMerchantStatistics: async (cancelTokenSource: CancelTokenSource): Promise<statisticResult> => {
        const response = await axios.get<statisticResult>('/api/merchant-statistics', {
            cancelToken: cancelTokenSource.token,
        });

        return response.data;
    },

    fetchServiceProviderStatistics: async (cancelTokenSource: CancelTokenSource): Promise<statisticResult> => {
        const response = await axios.get<statisticResult>('/api/service-provider-statistics', {
            cancelToken: cancelTokenSource.token,
        });

        return response.data;
    },

    checkOauthSession: async (): Promise<string | null> => {
        const response = await axios.get<{ redirectUrl: string | null }>('/api/oauth/session');

        return response.data.redirectUrl;
    },
});
